// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rs-0";